import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

/**
 * Represents the version information of the application.

 * This interface defines the structure of the application version object, containing a single property for the version string.

 * @interface AppVersion
 */
interface AppVersion {
    /**
     * The version string of the application.
     */
    version: string
}

/**
 * Service for retrieving application version information.

 * This service provides a method to fetch the current version of the application from a JSON file.

 * @export
 * @class VersionService
 */
@Injectable({
    providedIn: 'root',
})
export class VersionService {
    /**
     * Constructor for the VersionService.

     * @param http {HttpClient} The HTTP client to make requests.
     */
    constructor(private http: HttpClient) {}

    /**
     * Fetches the application version from the specified JSON file.

     * @returns {Observable<AppVersion>} An observable that emits the fetched application version.
     */
    getAppVersion(): Observable<AppVersion> {
        return this.http.get<AppVersion>('/assets/version.json')
    }
}
